/* eslint-disable */
import { makeStyles, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { maskDate } from '../../utils/masks';

/**
 * O indicador é um botão, mas dentro de uma tabela densa um link azul sublinhado
 * polui a leitura. Em repouso ele se parece com o texto das demais células e só
 * assume o laranja da marca no hover/foco; a seta em opacidade baixa é o que
 * sinaliza que a linha abre as propostas daquele consultor.
 */
const useStyles = makeStyles({
  inviterButton: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '2px',
    padding: 0,
    border: 'none',
    background: 'none',
    font: 'inherit',
    color: 'inherit',
    fontWeight: 500,
    textAlign: 'left',
    cursor: 'pointer',
    borderRadius: '4px',
    transition: 'color .2s',
    '&:hover': {
      color: '#f26522',
      textDecoration: 'underline',
    },
    '&:focus-visible': {
      color: '#f26522',
      outline: '2px solid #fc986a',
      outlineOffset: '2px',
    },
    '&:hover $inviterIcon': {
      opacity: 1,
    },
  },
  inviterIcon: {
    fontSize: '1rem',
    opacity: 0.4,
    transition: 'opacity .2s',
  },
});

const FiIndicationReportTableList = ({ listItem, totals = null, onSelectInviter = null }) => {
  const classes = useStyles();

  return (
    <TableContainer component={Paper} style={{ marginTop: '16px' }}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Indicador</TableCell>
            <TableCell align="right">Indicadas</TableCell>
            <TableCell align="right">Teve Interesse (F&I)</TableCell>
            <TableCell align="right">Sem interesse (F&I)</TableCell>
            <TableCell align="center">% Interesse (F&I)</TableCell>
            <TableCell align="right">Aguardando resposta do cliente</TableCell>
            <TableCell align="right">Cliente informou que não passou pelo F&I</TableCell>
            <TableCell align="right">Cliente negou que foi informado da Pessego</TableCell>
            <TableCell align="right">Cliente confirmou que foi informado da Pessego</TableCell>
            <TableCell align="right">% Confirmação com cliente</TableCell>
            <TableCell align="right">Seguros Vendidos</TableCell>
            <TableCell align="right">Conversão</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {listItem?.map((lead, index) => (
            <TableRow key={`indication-lead-${index}`} hover>
              <TableCell>
                {/* O groupBy do backend também devolve linhas sem indicador:
                    sem id não há drill-down, então nem vira link. */}
                {onSelectInviter && lead?.inviter_id ? (
                  <button
                    type="button"
                    className={classes.inviterButton}
                    title="Ver propostas indicadas por este consultor"
                    onClick={() => onSelectInviter(lead.inviter_id)}>
                    {lead?.inviter_name || '-'}
                    <ChevronRightIcon className={classes.inviterIcon} />
                  </button>
                ) : (
                  lead?.inviter_name || '-'
                )}
              </TableCell>
              <TableCell align="right">{lead?.total}</TableCell>
              <TableCell align="right">{lead?.fi_referral_accepted}</TableCell>
              <TableCell align="right">{lead?.fi_referral_no_accepted}</TableCell>
              <TableCell align="center">{lead?.fi_referral_percent}</TableCell>

              <TableCell align="center">{lead?.crm_contact_no_response}</TableCell>
              <TableCell align="center">{lead?.crm_contact_not_fi}</TableCell>
              <TableCell align="center">{lead?.crm_contact_denied}</TableCell>

              <TableCell align="right">{lead?.crm_contact_accepted}</TableCell>
              <TableCell align="right">{lead?.crm_contact_percent}</TableCell>
              <TableCell align="right">{lead?.sold}</TableCell>
              <TableCell align="right">{lead?.conversion_percent}</TableCell>
            </TableRow>
          ))}

          {totals && (
            <TableRow style={{ fontWeight: 'bold' }}>
              <TableCell style={{ fontWeight: 'bold' }}>Total</TableCell>
              <TableCell align="right" style={{ fontWeight: 'bold' }}>
                {totals.total}
              </TableCell>
              <TableCell align="right" style={{ fontWeight: 'bold' }}>
                {totals.fi?.accepted}
              </TableCell>
              <TableCell align="right" style={{ fontWeight: 'bold' }}>
                {totals.fi?.no_accepted}
              </TableCell>
              <TableCell align="center" style={{ fontWeight: 'bold' }}>
                {totals.fi?.percent}
              </TableCell>

              <TableCell align="center" style={{ fontWeight: 'bold' }}>
                {totals.crm?.no_response}
              </TableCell>
              <TableCell align="center" style={{ fontWeight: 'bold' }}>
                {totals.crm?.not_fi}
              </TableCell>
              <TableCell align="center" style={{ fontWeight: 'bold' }}>
                {totals.crm?.denied}
              </TableCell>

              <TableCell align="right" style={{ fontWeight: 'bold' }}>
                {totals.crm?.accepted}
              </TableCell>
              <TableCell align="right" style={{ fontWeight: 'bold' }}>
                {totals.crm?.percent}
              </TableCell>
              <TableCell align="right" style={{ fontWeight: 'bold' }}>
                {totals.sold}
              </TableCell>
              <TableCell align="right" style={{ fontWeight: 'bold' }}>
                {totals.conversion_percent}
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default FiIndicationReportTableList;
